import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import PrescribedDaysCreateForm from 'components/organismos/master/labor/PrescribedDaysCreateForm';
import FormContents from 'components/atoms/Form/FormContents';
import TabControl from 'components/atoms/TabControl';
import FormHeader from 'components/templates/FormHeader';
import { css } from '@emotion/core';

type SelectTab = 'add';
const SelectTab: {[key in SelectTab]: SelectTab} = {
  add: 'add',
};

const WorkingDaysCreatePage: React.FC = () => {
  const [selectTab, setSelectTab] = React.useState<SelectTab>(SelectTab.add);

  return (
    <SidebarTemplate>
      <FormHeader title="所定労働日数作成" />
      <FormContents customStyle={css({marginTop:'60px'})}>
        <div style={{paddingLeft: '15px', paddingTop:'16px'}}>
        <TabControl
          items={[
            {
              value: SelectTab.add,
              display: '所定労働日数',
            },
          ]}
          setValue={setSelectTab as (arg: string) => void}
          currentValue={selectTab}
          isFixed={true}
          type={1}
        />
        </div>
        <PrescribedDaysCreateForm />
      </FormContents>
    </SidebarTemplate>
  );
};

export default WorkingDaysCreatePage;
